<div
    kendoTooltip
    showOn="none"
    [tooltipTemplate]="template"
    filter=".k-grid td"
    (mouseover)="showTooltip($event)"
    class="common-kendo-table-container"
>
    <div class="common-kendo-table-area">
        <kendo-grid
            #kendoGrid="kendoGrid"
            [data]="gridDataResult"
            [height]="tableHeight"
            [style.maxHeight.px]="maxHeight"
            [pageSize]="pageSize"
            [skip]="skip"
            [pageable]="pageable"
            [sort]="sort"
            [sortable]="{
                mode: 'single',
                allowUnsort: false
            }"
            (sortChange)="sortChange($event)"
            [scrollable]="'scrollable'"
            [loading]="!tableDataProperties.isDataLoaded"
            (pageChange)="pageChange($event)"
            [ngClass]="{ 'lg-scrollbar': useLGScroll }"
            [selectable]="true"
            [kendoGridSelectBy]="kendoGridSelectById"
            [selectedKeys]="recordSelection"
            (cellClick)="cellClickHandler($event)"
            filterable="menu"
            [filter]="filter"
            (filterChange)="handleHeaderFilterChange($event)"
            (selectionChange)="selectionChangeHandler ? selectionChangeHandler($event) : null"
            (dataStateChange)="onStateChange($event)"
        >
            <ng-template kendoGridNoRecordsTemplate>
                <div class="no-data-message-area" *ngIf="noRecordsAvailable">
                    <no-data-screen [noDataType]="noDataType"> </no-data-screen>
                </div>
            </ng-template>
            <kendo-grid-column
                *ngFor="let field of columnsProperties"
                field="{{ field.fieldId }}"
                title="{{ field.fieldName }}"
                [headerClass]="field.headerClass"
                [headerStyle]="getHeaderStyles(field)"
                [class]="'cell-styles'"
                [style]="getColumnStyles(field)"
                [footerClass]="'footer-styles'"
                [footerStyle]="getHeaderStyles(field)"
                [sortable]="field.isSortable"
                [width]="field.width"
                [locked]="field.locked"
                [autoSize]="true"
                [filterable]="field.filterable"
                [filter]="field.filter === 'category' ? 'text' : field.filter"
                [hidden]="field.hideIf === 'ui' || field.hidden"
            >
                <ng-template
                    kendoGridFilterMenuTemplate
                    *ngIf="field.filter === 'category' && showHeaderFilter"
                    let-column="column"
                    let-filter="filter"
                    let-filterService="filterService"
                >
                    <kendogrid-filter-dropdown
                        [isPrimitive]="false"
                        [field]="field.fieldId"
                        [currentFilter]="filter"
                        [filterService]="filterService"
                        textField="{{ field.fieldId }}"
                        valueField="{{ field.fieldId }}"
                        [data]="distinctCategories[field.fieldId]"
                    >
                    </kendogrid-filter-dropdown>
                </ng-template>
                <div>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div
                            [ngStyle]="getCellStyle(dataItem, field)"
                            *ngIf="field.dataType === 'checkbox' && field.checkBoxProperties"
                        >
                            <p-checkbox
                                [(ngModel)]="dataItem[field.fieldId]"
                                [binary]="true"
                                (onChange)="onCheckboxChange(dataItem, field)"
                                style="margin: auto"
                                [disabled]="field.checkBoxProperties.disabled"
                                [ngStyle]="field.checkBoxProperties.style"
                                [title]="field.checkBoxProperties.title || ''"
                            />
                        </div>
                        <div
                            [ngStyle]="getCellStyle(dataItem, field)"
                            *ngIf="field.dataType === 'input' && field.inputProperties"
                        >
                            <mat-form-field
                                appearance="outline"
                                [ngStyle]="field.inputProperties.style"
                            >
                                <mat-label></mat-label>
                                <input
                                    (change)="onInputChange(dataItem, field)"
                                    matInput
                                    [(ngModel)]="dataItem[field.fieldId]"
                                    type="{{ field.inputProperties.type }}"
                                />
                            </mat-form-field>
                        </div>
                        <div
                            *ngIf="field.dataType === 'graph'"
                            [ngStyle]="getCellStyle(dataItem, field)"
                            (click)="hyperLinkHandler(field, dataItem)"
                        >
                            <column-bar-graph
                                [value]="dataItem[field.graphValue]"
                                [percent]="dataItem[field.fieldId]"
                                [format]="field.graphDataType"
                            >
                            </column-bar-graph>
                        </div>
                        <div
                            *ngIf="field.dataType === 'icon'"
                            [ngStyle]="getCellStyle(dataItem, field)"
                            (click)="iconClick(dataItem, field)"
                        >
                            <i
                                class="{{ field.iconProperties?.iconClass ?? '' }}"
                                aria-hidden="true"
                            ></i>
                        </div>
                        <div
                            [ngStyle]="getCellStyle(dataItem, field)"
                            *ngIf="field.dataType === 'string'"
                        >
                            <div *ngIf="!field.isHyperlink">
                                {{ dataItem[field.fieldId] }}
                            </div>
                            <div
                                *ngIf="field.isHyperlink"
                                (click)="hyperLinkHandler(field, dataItem)"
                            >
                                <span>{{ dataItem[field.fieldId] }}</span>
                            </div>
                        </div>
                        <div
                            [ngStyle]="getCellStyle(dataItem, field)"
                            *ngIf="field.dataType === 'boolean'"
                        >
                            {{ capitalizeFirstLetter(dataItem[field.fieldId]) }}
                        </div>
                        <div
                            [ngStyle]="getCellStyle(dataItem, field)"
                            *ngIf="field.dataType === 'date'"
                        >
                            {{ dataItem[field.fieldId] | date : 'MM/dd/yyyy' : 'UTC' }}
                        </div>
                        <div
                            [ngStyle]="getCellStyle(dataItem, field)"
                            *ngIf="field.dataType === 'percent'"
                        >
                            {{
                                (dataItem[field.fieldId]
                                    ? dataItem[field.fieldId] / 100
                                    : dataItem[field.fieldId]
                                ) | percent : field.dataFormat
                            }}
                        </div>
                        <div
                            [ngStyle]="getCellStyle(dataItem, field)"
                            *ngIf="field.dataType === 'number'"
                        >
                            {{ dataItem[field.fieldId] | number : field.dataFormat }}
                        </div>
                        <div
                            [ngStyle]="getCellStyle(dataItem, field)"
                            *ngIf="field.dataType === 'money' || field.dataType === 'currency'"
                        >
                            {{
                                dataItem[field.fieldId]
                                    | currency : 'USD' : 'symbol-narrow' : field.dataFormat
                                    | negativeToParens
                            }}
                        </div>
                        <div
                            *ngIf="field.dataType === 'chart' && field.chartProperties"
                            [ngStyle]="getCellStyle(dataItem, field)"
                            id="{{
                                field.fieldId + dataItem[field.chartProperties.chartToFieldId]
                            }}"
                        ></div>
                        <div
                            [ngStyle]="getCellStyle(dataItem, field)"
                            *ngIf="field.dataType === 'dynamic'"
                        >
                            <div
                                [ngStyle]="getCellStyle(dataItem, field)"
                                *ngIf="
                                    dataItem.format === 'money' || dataItem.format === 'currency'
                                "
                            >
                                {{
                                    dataItem[field.fieldId]
                                        | currency
                                            : 'USD'
                                            : 'symbol-narrow'
                                            : setIndividualDataFormatting(dataItem.precision)
                                        | negativeToParens
                                }}
                            </div>
                            <div
                                [ngStyle]="getCellStyle(dataItem, field)"
                                *ngIf="dataItem.format === 'number'"
                            >
                                {{
                                    dataItem[field.fieldId]
                                        | number : setIndividualDataFormatting(dataItem.precision)
                                }}
                            </div>
                            <div
                                [ngStyle]="getCellStyle(dataItem, field)"
                                *ngIf="dataItem.format === 'percentage'"
                            >
                                {{
                                    (dataItem[field.fieldId]
                                        ? dataItem[field.fieldId] / 100
                                        : dataItem[field.fieldId]
                                    ) | percent : setIndividualDataFormatting(dataItem.precision)
                                }}
                            </div>
                        </div>
                    </ng-template>
                    <!--  TODO: Add aggregation / summary logic. Below commented out section is some example code -->
                    <div
                        *ngIf="
                            gridDataResult?.data.length > 0 &&
                            aggregateResult &&
                            aggregateResult[field.aggregationId] &&
                            !field.hideFooterValue
                        "
                    >
                        <ng-template
                            kendoGridFooterTemplate
                            *ngIf="
                                field.dataType === 'money' || field.aggregationValueType === 'money'
                            "
                        >
                            <span
                                title="{{
                                    aggregateResult[field.aggregationId][field.aggregationType]
                                }}"
                            >
                                {{ field.aggregationTitle }}
                                {{
                                    aggregateResult[field.aggregationId][field.aggregationType]
                                        | currency : 'USD' : 'symbol' : '1.0-0'
                                        | negativeToParens
                                }}<span *ngIf="field.label">{{ field.label }}</span>
                            </span>
                        </ng-template>
                        <ng-template kendoGridFooterTemplate>
                            <span
                                title="{{
                                    aggregateResult[field.aggregationId][field.aggregationType]
                                }}"
                            >
                                {{ field.aggregationTitle }}
                                {{ aggregateResult[field.aggregationId][field.aggregationType]
                                }}<span *ngIf="field.label">{{ field.label }}</span>
                            </span>
                        </ng-template>
                    </div>

                    <!--<ng-template kendoGridFooterTemplate
                             *ngIf="showSummary && field.fieldOrder === 0 && gridData.length > 0"
                             let-column="column">
                    Summary
                </ng-template>
                <div *ngIf="showSummary && field.fieldOrder > 0 && field.aggregationType && aggregate[field.fieldId] && gridData.length > 0">-->
                    <!-- TODO: Further simplify this area -->
                    <!--<ng-template kendoGridFooterTemplate
                                 *ngIf="field.dataType === 'money' && field.aggregationType !== 'count'">
                        <span title="{{ aggregate[field.fieldId][field.aggregationType] | currency: 'USD':'symbol-narrow':field.dataFormat }}">
                            {{ field.aggregationTitle }}
                            {{ aggregate[field.fieldId][field.aggregationType] | currency: 'USD':'symbol-narrow':field.dataFormat | negativeToParens }}
                        </span>
                    </ng-template>
                    <ng-template kendoGridFooterTemplate
                                 *ngIf="field.dataType === 'number' && field.aggregationType !== 'count'">
                        <span title="{{ aggregate[field.fieldId][field.aggregationType] | number: field.dataFormat }}">
                            {{ field.aggregationTitle }}
                            {{ aggregate[field.fieldId][field.aggregationType] | number: field.dataFormat }}
                        </span>
                    </ng-template>
                    <ng-template kendoGridFooterTemplate *ngIf="field.dataType === 'percent'">
                        <span title="{{ aggregate[field.fieldId][field.aggregationType] | number: field.dataFormat }}">
                            {{ field.aggregationTitle }}
                            {{ aggregate[field.fieldId][field.aggregationType] | number: field.dataFormat }}%
                        </span>
                    </ng-template>
                    <ng-template kendoGridFooterTemplate
                                 *ngIf="field.dataType === 'boolean' && field.aggreationType !== 'count'">
                        <span title="{{ aggregate[field.fieldId][field.aggregationType] }}">
                            {{ field.aggregationTitle }}
                            {{ aggregate[field.fieldId][field.aggregationType] }}
                        </span>
                    </ng-template>
                    <ng-template kendoGridFooterTemplate
                                 *ngIf="field.aggregationType === 'count'">
                        <span title="{{ aggregate[field.fieldId][field.aggregationType] }}">
                            {{ field.aggregationTitle }}
                            {{ aggregate[field.fieldId][field.aggregationType] }}
                        </span>
                    </ng-template>
                </div>-->
                    <!---------------------------------------------------------------->
                </div>
            </kendo-grid-column>
            <kendo-grid-excel [fileName]="exportFileName" [fetchData]="getExcelExportData">
                <kendo-excelexport-column
                    *ngFor="let field of columnsProperties"
                    field="{{ field.fieldId }}"
                    title="{{ field.fieldName }}"
                    [hidden]="field.hideIf === 'excel' || field.hidden"
                >
                </kendo-excelexport-column>
            </kendo-grid-excel>
            <ng-template kendoPagerTemplate>
                <kendo-pager-prev-buttons class="text-color-black"></kendo-pager-prev-buttons>
                <kendo-pager-input class="text-color-black"></kendo-pager-input>
                <kendo-pager-info class="text-color-black"></kendo-pager-info>
                <kendo-pager-next-buttons class="text-color-black"></kendo-pager-next-buttons>
                <kendo-pager-page-sizes class="text-color-black" [pageSizes]="[10, 25, 50, 100]">
                </kendo-pager-page-sizes>
            </ng-template>
        </kendo-grid>
    </div>
</div>
